<div class="pwc-container">
  <gstar-header />
  <div class="d-flex content">
    <gstar-sidebar #sidebar class="sidebar" />
    <main class="w-100 d-flex flex-column p-1">
      <div
        class="position-relative flex-grow-1 main-container"
        [style.overflow]="(showShadowLayer | async) ? 'initial' : 'auto'">
        @if (showShadowLayer | async) {
          <div [class.shadow-layer]="showShadowLayer"></div>
        }
        <div #mainContainer class="mt-5 w-100 main-content">
          <ng-content></ng-content>
        </div>
        <gstar-footer
          #footer
          class="footer"
          [style.width]="
            'calc(100% - ' + sidebar.navElement()?.widthValue() + ')'
          " />
      </div>
    </main>
  </div>
</div>

@if (isLoaded()) {
  <gstar-legal-disclaimer [(showDrawer)]="footer.showDisclaimer" />
}
